export default function scrollToElement(id) {
    let offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, parentId = arguments.length > 2 ? arguments[2] : void 0, horizontal = arguments.length > 3 ? arguments[3] : void 0;
    if (id) {
        const element = document.getElementById(id);
        if (element) {
            if (offset && !parentId) {
                // constants
                const elementPosition = element.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.scrollY - offset;
                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth"
                });
            } else if (parentId) {
                // constants
                const elementPosition = horizontal ? element.offsetLeft : element.offsetTop;
                const parent = document.getElementById(parentId);
                parent.scrollTo({
                    top: horizontal ? 0 : elementPosition - offset,
                    left: horizontal ? elementPosition - offset : 0,
                    behavior: 'smooth'
                });
            } else element.scrollIntoView();
        }
    }
}
